export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7300.e0f55b87.jpg";